<div class="modal-header">
  <h2 mat-dialog-title>{{ data.name }}</h2>
  <div class="badge-container">
    <mat-chip-set>
      @if (data.is_latest) {
        <mat-chip class="latest-chip" highlighted color="primary">Latest</mat-chip>
      }
      @if (agentStatus) {
        <mat-chip highlighted>
          {{ agentStatus | agentStatus }}
        </mat-chip>
      }
    </mat-chip-set>
  </div>
</div>

<mat-dialog-content>
  <section class="description-section">
    <h4>Template ID:</h4>
    <code class="id-text">{{ data.id }}</code>
  </section>

  <mat-divider></mat-divider>

  <section class="description-section">
    <h4>Version</h4>
    <p>{{ data.version }}</p>
  </section>

  <mat-divider></mat-divider>

  <section class="description-section">
    <h4>Created at</h4>
    <p>{{ data.created_at | date: 'medium' }}</p>
  </section>

  <mat-divider></mat-divider>

  <section class="description-section">
    <h4>Updated at</h4>
    <p>{{ data.updated_at | date: 'medium' }}</p>
  </section>

  @if (agentStatus) {
    <mat-divider></mat-divider>
    <section class="description-section">
      <h4>Ai generation status</h4>
      <mat-chip highlighted>
        {{ agentStatus | agentStatus }}
      </mat-chip>
    </section>
  }
  <mat-divider></mat-divider>
  <section class="description-section">
    <h4>Default Personas</h4>
    @if (personas$ | async; as personaNames) {
      @if (personaNames.length > 0) {
        <ul class="persona-list">
          @for (name of personaNames; track name) {
            <li>{{ name }}</li>
          }
        </ul>
      } @else {
        <p>No default personas assigned.</p>
      }
    } @else {
      <p>Loading personas...</p>
    }
  </section>

  <mat-divider></mat-divider>
  <section class="description-section">
    <h4>Description</h4>
    <p>{{ data.description || 'No description provided for this template.' }}</p>
  </section>

  @if (data.s3_key) {
    <div class="file-status">
      <mat-icon color="primary">check_circle</mat-icon>
      <span>Source file is attached and available for download.</span>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    [disabled]="isTriggering || agentStatus === 'IN_PROGRESS' || agentStatus === 'COMPLETED'"
    (click)="triggerAgent()">
    @if (isTriggering) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Trigger Agent
    }
  </button>
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
